import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { STRINGS } from "../lib/i18n";
import { logger } from "../lib/logger";

const I18nCtx = createContext(null);
export const useI18n = () => useContext(I18nCtx);

const STORAGE_KEY = "cs.lang";

export function I18nProvider({ children }) {
  // Default to English so first-time users in international tenants land on the
  // language most likely to be understood. Returning users keep whatever they
  // selected last via the localStorage override below.
  const [lang, setLang] = useState(() => {
    try { return localStorage.getItem(STORAGE_KEY) || "en"; } catch { return "en"; }
  });

  useEffect(() => {
    try { localStorage.setItem(STORAGE_KEY, lang); }
    catch (e) {
      // Storage may be unavailable (Safari private mode, iframe sandbox) — non-fatal.
      logger.debug("i18n persistence skipped:", e?.message);
    }
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback((key, params) => {
    let s = (STRINGS[lang] && STRINGS[lang][key]) || (STRINGS.pt[key]) || key;
    if (params && typeof s === "string") {
      for (const [k, v] of Object.entries(params)) {
        s = s.replace(new RegExp(`\\{${k}\\}`, "g"), String(v));
      }
    }
    return s;
  }, [lang]);

  const value = useMemo(() => ({ lang, setLang, t }), [lang, t]);
  return <I18nCtx.Provider value={value}>{children}</I18nCtx.Provider>;
}
